// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sequence-list-container {
  display: flex;
  flex-direction: column;
  gap: 17px;
  padding: 15px 25px;
  background-color: #FFFFFF;
  border-top: 1px solid #E0E6EB;
  border-radius: 4px;
}
.sequence-list-container .sequence-item {
  background-color: #FFFFFF;
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  padding: 12px 15px;
  transition: all 0.2s ease;
  position: relative;
}
.sequence-list-container .sequence-item .or-badge {
  position: absolute;
  top: -8px;
  left: -15px;
  background-color: #FFFFFF;
  border: 1px solid #D3E1ED;
  border-radius: 16.7px;
  padding: 4px 2px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 8.35px;
  color: #365A64;
  text-align: center;
  min-width: 30px;
  z-index: 1;
}
.sequence-list-container .sequence-item .sequence-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.sequence-list-container .sequence-item .sequence-header .sequence-title {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #142A31;
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
}
.sequence-list-container .sequence-item .sequence-header .sequence-title .sequence-clear-btn {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #A8B5BF;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.sequence-list-container .sequence-item .sequence-header .sequence-title .sequence-clear-btn:hover {
  background-color: #E0E6EB;
}
.sequence-list-container .sequence-item .sequence-header .sequence-delete-icon {
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sequence-list-container .sequence-item .sequence-header .sequence-delete-icon:hover {
  opacity: 0.7;
}
.sequence-list-container .sequence-item .sequence-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 34px;
  align-items: center;
}
.sequence-list-container .sequence-item .sequence-filters .filter-chip-mui {
  margin: 0;
  padding-right: 12px;
}
.sequence-list-container .sequence-item .sequence-filters .add-filter-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  background-color: #40A0C1;
  border: none;
  border-radius: 45px;
  padding: 8px 16px;
  height: 34px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.sequence-list-container .sequence-item .sequence-filters .add-filter-btn:hover {
  opacity: 0.9;
}
.sequence-list-container .sequence-item .sequence-filters .add-filter-btn span {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #FFFFFF;
}
.sequence-list-container .add-sequence-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  background-color: #40A0C1;
  border: none;
  border-radius: 45px;
  padding: 8px 20px;
  height: 33px;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  transition: opacity 0.2s ease;
  align-self: flex-start;
  margin-top: 5px;
}
.sequence-list-container .add-sequence-btn:hover {
  opacity: 0.9;
}
.sequence-list-container .add-sequence-btn span {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/pages/Mapping/Reports/SequenceList.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;AACF;AACE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AACI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AACN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAEM;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAAR;AAEQ;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;AAAV;AAEU;EACE,yBAAA;AAAZ;AAKM;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAKQ;EACE,YAAA;AAHV;AAQI;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AANN;AASM;EACE,SAAA;EACA,mBAAA;AAPR;AAUM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;AARR;AAUQ;EACE,YAAA;AARV;AAWQ;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AATV;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;AAdJ;AAgBI;EACE,YAAA;AAdN;AAiBI;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAfN","sourcesContent":[".sequence-list-container {\n  display: flex;\n  flex-direction: column;\n  gap: 17px;\n  padding: 15px 25px;\n  background-color: #FFFFFF;\n  border-top: 1px solid #E0E6EB;\n  border-radius: 4px;\n\n  .sequence-item {\n    background-color: #FFFFFF;\n    border: 1px solid #D3E1ED;\n    border-radius: 5px;\n    padding: 12px 15px;\n    transition: all 0.2s ease;\n    position: relative;\n\n    .or-badge {\n      position: absolute;\n      top: -8px;\n      left: -15px;\n      background-color: #FFFFFF;\n      border: 1px solid #D3E1ED;\n      border-radius: 16.7px;\n      padding: 4px 2px;\n      font-family: 'Inter', sans-serif;\n      font-weight: 400;\n      font-size: 8.35px;\n      color: #365A64;\n      text-align: center;\n      min-width: 30px;\n      z-index: 1;\n    }\n\n    .sequence-header {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-bottom: 10px;\n\n      .sequence-title {\n        font-family: 'Inter', sans-serif;\n        font-weight: 500;\n        font-size: 14px;\n        color: #142A31;\n        flex: 1;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .sequence-clear-btn {\n          font-family: 'Inter', sans-serif;\n          font-weight: 500;\n          font-size: 14px;\n          color: #A8B5BF;\n          cursor: pointer;\n          padding: 2px 8px;\n          border-radius: 4px;\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background-color: #E0E6EB;\n          }\n        }\n      }\n\n      .sequence-delete-icon {\n        cursor: pointer;\n        padding: 2px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &:hover {\n          opacity: 0.7;\n        }\n      }\n    }\n\n    .sequence-filters {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 12px;\n      min-height: 34px;\n      align-items: center;\n\n      // Material-UI Chip styles are handled via sx prop in component\n      .filter-chip-mui {\n        margin: 0;\n        padding-right: 12px;\n      }\n\n      .add-filter-btn {\n        display: flex;\n        align-items: center;\n        gap: 7px;\n        background-color: #40A0C1;\n        border: none;\n        border-radius: 45px;\n        padding: 8px 16px;\n        height: 34px;\n        cursor: pointer;\n        transition: opacity 0.2s ease;\n\n        &:hover {\n          opacity: 0.9;\n        }\n\n        span {\n          font-family: 'Inter', sans-serif;\n          font-weight: 700;\n          font-size: 14px;\n          color: #FFFFFF;\n        }\n      }\n    }\n  }\n\n\n  .add-sequence-btn {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    background-color: #40A0C1;\n    border: none;\n    border-radius: 45px;\n    padding: 8px 20px;\n    height: 33px;\n    cursor: pointer;\n    width: fit-content;\n    transition: opacity 0.2s ease;\n    align-self: flex-start;\n    margin-top: 5px;\n\n    &:hover {\n      opacity: 0.9;\n    }\n\n    span {\n      font-family: 'Inter', sans-serif;\n      font-weight: 700;\n      font-size: 14px;\n      color: #FFFFFF;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
